import { Modal } from "antd";
import { TaxCase } from "../../../types/taxTypes";
import ModalContent from "./modalContent";
import { ModelMatch } from "../../../types/motorAtlasCatalogTypes";
import { ModalConfig, SubmitPayload } from "./util";

const { confirm } = Modal;


export default async function openAsyncModal(payload: ModalConfig): Promise<SubmitPayload | null> {
  const cancelBtnId = `motor_atlas_catalog_mapper__modal_cancel_btn`;
  const closeModal = () => document.getElementById(cancelBtnId)?.click();

  return new Promise((resolve, reject) => {
    confirm({
      title: null,
      className: "motor_atlas_catalog_mapper_modal open-modal-wp",
      content: (
        <ModalContent
          submit={(submitPayload) => {
            resolve(submitPayload);
            closeModal();
          }}
          onCancel={closeModal}
          payload={payload}
        />
      ),
      icon: null,
      width: payload?.views?.hideSourceVehicle ? 720 : 1440,
      maskClosable: true,
      cancelButtonProps: {
        id: cancelBtnId,
        hidden: true,
      },
      okButtonProps: {
        hidden: true,
      },
      okCancel: true,
      onCancel() {
        resolve(null)
      },
    });
  });
}
